// packages import
import { Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
// component import
import { ContentHead } from '../../../components/common/ContentHead'
import { EmptyData } from '../../../components/common/EmptyData'
import { KeyPressSearch } from '../../../components/common/KeyPressSearch'
import { AddNewCustomTask } from '../../../components/customTasks/AddNewCustomTask'
import { CustomTasksListing } from '../../../components/customTasks/CustomTasksListing'
import { DeleteCustomTask } from '../../../components/customTasks/DeleteCustomTask'
import { ViewCurrentCustomTask } from '../../../components/customTasks/ViewCurrentCustomTask'
// others
import { Maybe, Task, TaskType, TasksPayload, useFetchAllTasksLazyQuery } from '../../../../generated'
import { GRAPHQL_QUERY_POLICY } from '../../../constants'
import { AppContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'
import { CardBox } from '../../../theme/styleComponents'
import { flexCenter } from '../../../theme/styleConstants'

export const CustomTasks = () => {
  const [allTasks, setAllTasks] = useState<TasksPayload['tasks']>()
  const [currentCustomTask, setCurrentCustomTask] = useState<Maybe<Task>>()
  const { dispatch: reducerDispatch, currentPage, pageLimit, searchValue } = useContext(AppContext)

  const [fetchAllTasks, { loading, refetch }] = useFetchAllTasksLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,

    onError() {
      setAllTasks([])
    },

    onCompleted(data) {
      if (data) {
        const { fetchAllTasks } = data
        const { response, tasks, pagination } = fetchAllTasks || {}
        const { totalPages, totalCount } = pagination || {}
        const { status } = response || {}

        if (status === 200 && tasks) {
          setAllTasks(tasks)
          totalPages && reducerDispatch({ type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: totalPages })
          totalCount && reducerDispatch({ type: ActionType.SET_TOTAL_DATA_COUNT, totalDataCount: totalCount })
        }
      }
    }
  })

  useEffect(() => {
    fetchAllTasks({
      variables: {
        tasksInput: {
          paginationOptions: {
            page: currentPage,
            limit: pageLimit
          },
          searchValue: searchValue || '',
          taskType: TaskType.Custom
        }
      }
    })
    // eslint-disable-next-line
  }, [pageLimit, currentPage, searchValue])

  useEffect(() => {
    return () => {
      reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
      reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
    }
    // eslint-disable-next-line
  }, [])

  const isEmpty = !loading && allTasks && allTasks?.length === 0

  return (
    <>
      <CardBox marginTop={3}>
        <ContentHead title="Custom Tasks" buttonText={'Create'} />

        <KeyPressSearch searchPlaceholder="Search Custom Task" />

        {isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 255px)' }}>
            <EmptyData title={'No custom task found'} />
          </Box>
        ) : (
          <CustomTasksListing
            loading={loading}
            allTasks={allTasks}
            currentCustomTask={currentCustomTask}
            setCurrentCustomTask={setCurrentCustomTask}
          />
        )}
      </CardBox>

      <AddNewCustomTask refetch={refetch} />
      <DeleteCustomTask
        refetch={refetch}
        currentCustomTask={currentCustomTask}
        setCurrentCustomTask={setCurrentCustomTask}
      />
      <ViewCurrentCustomTask
        refetch={refetch}
        loading={loading}
        currentCustomTask={currentCustomTask}
        setCurrentCustomTask={setCurrentCustomTask}
      />
    </>
  )
}
